(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m2u-journey-foundation"] && !Shopify.designMode) return;
  try {
    (()=>{
 const config=document.querySelector('[data-m2u-journey]');if(!config)return;
 const confidence=document.querySelector('[data-m2u-confidence]'),trust=document.querySelector('.t4s-product__info-container .m2u-purchase-trust');if(confidence&&trust)trust.after(confidence);
 const cartNote=()=>{document.querySelectorAll('#t4s-mini_cart .t4s-btn__checkout,.template-cart button[name="checkout"]').forEach(button=>{if(button.previousElementSibling?.classList.contains('m2u-cart-guidance'))return;const p=document.createElement('p');p.className='m2u-cart-guidance';p.textContent=config.dataset.cartNote;button.before(p);});};
 cartNote();const drawer=document.querySelector('#t4s-mini_cart');if(drawer)new MutationObserver(cartNote).observe(drawer,{childList:true,subtree:true});
 if(!document.body.classList.contains('template-collection'))return;
 const collectionRoot=document.querySelector('.t4s-main-collection-page[data-ntajax-container]');if(!collectionRoot)return;
 const grid=()=>collectionRoot.querySelector('[data-contentlm-replace].t4s-products');
 const count=()=>grid()?.querySelectorAll('.t4s-product').length||0;
 const key=()=> 'm2u-browse-v1:'+location.pathname+location.search;
 const forget=storageKey=>{try{sessionStorage.removeItem(storageKey);}catch(_){}};
 const productHandle=link=>{try{const url=new URL(link.href,location.origin);if(url.origin!==location.origin)return '';const handle=url.pathname.split('/products/')[1]?.split('/')[0]||'';return /^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)?handle:'';}catch(_){return '';}};
 const handles=()=>Array.from(grid()?.querySelectorAll('.t4s-product a[href]')||[]).map(productHandle).filter(Boolean);
 const validState=saved=>saved&&typeof saved==='object'&&!Array.isArray(saved)&&Number.isInteger(saved.count)&&saved.count>0&&saved.count<=1000&&Number.isFinite(saved.y)&&saved.y>=0&&saved.y<=10000000&&Number.isFinite(saved.time)&&saved.time<=Date.now()&&Date.now()-saved.time<=1800000&&typeof saved.first==='string'&&/^[a-z0-9][a-z0-9-]{0,254}$/.test(saved.first);
 const paginationButton=previous=>{
  const selector=previous?'[data-wrap-lm-prev] a[data-load-more][data-is-prev]':'[data-wrap-lm] a[data-load-more]:not([data-is-prev])';
  const button=collectionRoot.querySelector(selector);if(!button||button.closest('[data-ntajax-container]')!==collectionRoot)return null;
  try{const url=new URL(button.href,location.origin),current=new URL(location.href);if(url.origin!==current.origin||url.pathname.replace(/\/+$/,'')!==current.pathname.replace(/\/+$/,''))return null;for(const name of ['page','section_id']){url.searchParams.delete(name);current.searchParams.delete(name);}url.searchParams.sort();current.searchParams.sort();if(url.search!==current.search)return null;}catch(_){return null;}
  return button;
 };
 const loadNativePage=button=>new Promise((resolve,reject)=>{
  const before=count();let settled=false;
  const finish=error=>{if(settled)return;settled=true;clearTimeout(timer);observer.disconnect();error?reject(error):resolve();};
  const changed=()=>{if(!collectionRoot.isConnected||!grid())finish(new Error('Collection changed'));else if(count()>before)finish();};
  const observer=new MutationObserver(changed);const timer=setTimeout(()=>finish(new Error('Pagination timeout')),12000);
  observer.observe(collectionRoot,{childList:true,subtree:true});
  const click=new MouseEvent('click',{bubbles:true,cancelable:true,view:window});click.preventDefault();
  try{button.dispatchEvent(click);changed();}catch(error){finish(error);}
 });
 let restoring=false;
 document.addEventListener('click',e=>{const a=e.target.closest?.('a[href]');if(!a||!productHandle(a)||!grid()?.contains(a)||restoring||e.button>0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||a.target==='_blank')return;const saved={count:count(),y:scrollY,time:Date.now(),first:handles()[0]};if(!validState(saved))return;try{sessionStorage.setItem(key(),JSON.stringify(saved));}catch(_){}},true);
 const restore=async e=>{
  if(e.persisted||restoring||!grid())return;
  const storageKey=key();let saved;try{saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');}catch(_){forget(storageKey);return;}
  if(!validState(saved)){forget(storageKey);return;}
  const isBack=performance.getEntriesByType('navigation')[0]?.type==='back_forward';
  let fromProduct=false;try{fromProduct=!!productHandle({href:document.referrer});}catch(_){}
  if(!isBack&&!fromProduct)return;
  restoring=true;const p=document.createElement('p');p.className='m2u-browse-status';p.setAttribute('role','status');p.textContent=config.dataset.restoring;grid().before(p);
  try{
   const requested=new Set();
   for(let attempt=0;attempt<20;attempt++){
    const previous=!handles().includes(saved.first)?paginationButton(true):null;
    if(!previous&&count()>=saved.count)break;
    const button=previous||paginationButton(false);if(!button||requested.has(button.href))throw new Error('Pagination unavailable');
    requested.add(button.href);await loadNativePage(button);
   }
   if(count()<saved.count)throw new Error('Incomplete restoration');
   p.remove();requestAnimationFrame(()=>scrollTo({top:saved.y,behavior:'instant'}));
  }catch(_){p.textContent=config.dataset.restoreFailed;}
  finally{restoring=false;forget(storageKey);}
 };
 window.addEventListener('pageshow',restore);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m2u-magnesium-runtime"] && !Shopify.designMode) return;
  try {
    (()=>{
 if(customElements.get('m2u-magnesium-offer'))return;
 let busy=false;
 const root=()=>window.Shopify?.routes?.root||'/';
 const copy=()=>JSON.parse(document.getElementById('m2u-magnesium-copy')?.textContent||'{}');
 const getJSON=async url=>{const r=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});if(!r.ok)throw Error('read');return r.json()};
 class MagnesiumOffer extends HTMLElement{
  connectedCallback(){
   this.button=this.querySelector('[data-m2u-magnesium-add]');this.status=this.querySelector('[role="status"]');
   if(!this.button||this.bound)return;
   this.bound=true;this.button.addEventListener('click',()=>this.add());
   this.expiry=setTimeout(()=>{this.hidden=true},Math.max(0,Number(this.dataset.expires)-Date.now()));
  }
  disconnectedCallback(){clearTimeout(this.expiry)}
  message(key){this.status.textContent=copy()[key]||key}
  async add(){
   if(busy)return;
   if(Date.now()>=Number(this.dataset.expires)){this.hidden=true;return}
   const label=this.button.textContent;let posted=false,confirmed=false;
   busy=true;this.button.disabled=true;this.button.textContent=copy().adding;
   try{
    const cart=await getJSON(root()+'cart.js');
    if(cart.items.some(i=>String(i.product_id)===this.dataset.productId)){
     this.message('existing');this.querySelector('.m2u-magnesium-offer__cart').hidden=false;return;
    }
    const eligible=this.dataset.eligibleIds.split(',');
    const items=[{id:Number(this.dataset.variantId),quantity:1}];
    if(this.dataset.context==='product'){
     const form=document.getElementById(this.dataset.formId);
     const data=form?new FormData(form):null;
     const variant=Number(data?.get('id')),quantity=Number(data?.get('quantity')||1);
     const submit=form?.querySelector('[name="add"]');
     if(!variant||!Number.isInteger(quantity)||quantity<1||!eligible.includes(this.dataset.currentProduct)||submit?.disabled||submit?.getAttribute('aria-disabled')==='true'){
      this.message('choose');return;
     }
     const properties={};for(const [key,value] of data.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match&&typeof value==='string')properties[match[1]]=value}
     const base={id:variant,quantity};if(Object.keys(properties).length)base.properties=properties;
     if(data.get('selling_plan'))base.selling_plan=Number(data.get('selling_plan'));
     items.unshift(base);
    }else if(!cart.items.some(i=>eligible.includes(String(i.product_id)))){
     this.message('qualification');return;
    }
    posted=true;
    const response=await fetch(root()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:['cart_data','mini_cart'],sections_url:window.location.pathname})});
    if(!response.ok){
     const failureKey=response.status===422?'stock':'failed';
     const explain=offer=>{
      const status=offer.querySelector('[role="status"]'),button=offer.querySelector('[data-m2u-magnesium-add]'),link=offer.querySelector('.m2u-magnesium-offer__cart');
      if(status)status.textContent=copy()[failureKey]||failureKey;
      if(button)button.hidden=true;
      if(link)link.hidden=false;
     };
     explain(this);
     try{
      await getJSON(root()+'cart.js');
      const url=new URL(window.location.href);url.searchParams.set('sections','cart_data,mini_cart');
      const sections=await getJSON(url),native=window.T4SThemeSP?.Cart;
      if(native?.renderContents&&sections?.cart_data?.includes('[t4s_split1]')&&sections?.mini_cart?.includes('data-cart-items'))native.renderContents(sections,true);
     }catch(reconciliationError){}
     document.querySelectorAll('m2u-magnesium-offer').forEach(explain);
     return;
    }
    confirmed=true;const result=await response.json();
    this.message('added');
    if(window.location.pathname.replace(/\/$/,'').endsWith('/cart')){window.location.reload();return}
    const native=window.T4SThemeSP?.Cart;
    let sections=result.sections;
    if(!sections?.cart_data?.includes('[t4s_split1]')||!sections?.mini_cart?.includes('data-cart-items')){
     const url=new URL(window.location.href);url.searchParams.set('sections','cart_data,mini_cart');sections=await getJSON(url);
    }
    if(native?.renderContents&&sections?.cart_data&&sections?.mini_cart){
     native.renderContents(sections,true);
     document.querySelectorAll('m2u-magnesium-offer[data-context="product"]').forEach(el=>{el.hidden=true});
    }else{window.location.href=root()+'cart'}
   }catch(error){
    if(confirmed){window.location.href=root()+'cart';return}
    this.message('failed');this.querySelector('.m2u-magnesium-offer__cart').hidden=false;
    if(posted){this.button.hidden=true}
   }finally{busy=false;this.button.disabled=false;this.button.textContent=label}
  }
 }
 customElements.define('m2u-magnesium-offer',MagnesiumOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m2u-product-confidence"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-m2u-confidence]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('[data-m2u-photo-dialog]');
    let photoOpener;
    if (dialog && typeof dialog.showModal === 'function') {
      const photo = dialog.querySelector('[data-m2u-large-photo]');
      const scroll = dialog.querySelector('.m2u-confidence__photo-scroll');
      const zoom = dialog.querySelector('[data-m2u-photo-zoom]');
      root.querySelectorAll('[data-m2u-photo]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        photoOpener = link;
        photo.src = link.href;
        photo.alt = link.dataset.photoAlt || root.dataset.productTitle;
        dialog.querySelector('[data-m2u-full-image]').href = link.href;
        scroll.classList.remove('is-zoomed');
        zoom.setAttribute('aria-pressed', 'false');
        dialog.showModal();
        dialog.querySelector('[data-m2u-photo-close]').focus();
      }));
      dialog.querySelector('[data-m2u-photo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { photoOpener?.focus(); });
      zoom.addEventListener('click', () => { const active = scroll.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed', String(active)); scroll.scrollTo(0, 0); });
    }
    root.querySelector('[data-m2u-review-link]')?.addEventListener('click', () => {
      const nativeLink = document.querySelector('.t4s-product__review[data-go-id]');
      if (nativeLink) nativeLink.click();
      const widget = document.getElementById('judgeme_product_reviews');
      if (widget) {
        widget.closest('details')?.setAttribute('open', '');
        window.setTimeout(() => { widget.setAttribute('tabindex', '-1'); widget.focus({preventScroll:true}); widget.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); }, 200);
      }
    });
    const params = new URLSearchParams(location.search);
    const isReturn = params.get('utm_content') === 'buy_again' || /^replenishment_/.test(params.get('utm_campaign') || '') || params.get('buy_again') === '1';
    const returnPanel = root.querySelector('[data-m2u-return]');
    if (isReturn && returnPanel) {
      const productArea = root.closest('[data-product-featured]') || document;
      const form = productArea.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        returnPanel.hidden = false;
        form.parentElement.insertBefore(returnPanel, form);
        returnPanel.querySelector('[data-m2u-return-focus]').addEventListener('click', () => {
          const target = form.querySelector('input[name="quantity"]:not([type="hidden"])') || form.querySelector('[name="add"]:not([disabled])') || form.querySelector('[data-notify-stock-btn]');
          form.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          target?.focus({preventScroll:true});
        });
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  if (!window.m2uRestockFormGuard) {
    window.m2uRestockFormGuard = true;
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!form.matches?.('.m2u-restock__form')) return;
      const status = form.querySelector('[data-m2u-restock-status]');
      if (form.dataset.submitting === 'true') { event.preventDefault(); return; }
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      if (!navigator.onLine) { event.preventDefault(); status.textContent = status.dataset.offline; return; }
      form.dataset.submitting = 'true';
      form.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.pending;
      const button = form.querySelector('[type="submit"]');
      window.setTimeout(() => {
        if (event.defaultPrevented) { delete form.dataset.submitting; form.removeAttribute('aria-busy'); status.textContent = ''; return; }
        button.disabled = true;
      }, 0);
      window.setTimeout(() => {
        if (!form.isConnected || form.dataset.submitting !== 'true') return;
        delete form.dataset.submitting;
        form.removeAttribute('aria-busy');
        button.disabled = false;
        status.textContent = status.dataset.retry;
      }, 20000);
    }, true);
    window.addEventListener('pageshow', () => document.querySelectorAll('.m2u-restock__form').forEach(form => {
      delete form.dataset.submitting;
      form.removeAttribute('aria-busy');
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = false;
    }));
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m2u-quick-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('m2u-quick-filters')) {
  customElements.define('m2u-quick-filters', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const form = this.querySelector('[data-m2u-filter-form]');
      if (!form) return;
      const owned = new Set(Array.from(this.querySelectorAll('[data-m2u-owned]'), element => element.dataset.m2uOwned));
      const transient = name => name === 'page' || /^page_/.test(name) || name === 'section_id' || name === 'sections';
      const currentSort = new URL(window.location.href).searchParams.get('sort_by');
      const sort = form.querySelector('[data-m2u-sort]');
      if (currentSort && Array.from(sort.options).some(option => option.value === currentSort)) sort.value = currentSort;
      this.querySelectorAll('details').forEach(detail => {
        const count = detail.querySelector('[data-m2u-selected]');
        if (!count) return;
        detail.addEventListener('change', () => {
          const selected = detail.querySelectorAll('input:checked').length;
          count.hidden = selected === 0;
          count.textContent = count.dataset.template.replace('__COUNT__', selected);
        }, { signal });
      });
      const validatePrices = () => {
        let valid = true;
        this.querySelectorAll('[data-m2u-price-range]').forEach(range => {
          const minimum = range.querySelector('[data-m2u-price="min"]');
          const maximum = range.querySelector('[data-m2u-price="max"]');
          const reversed = minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber;
          maximum.setCustomValidity(reversed ? range.dataset.error : '');
          if (reversed) valid = false;
        });
        return valid;
      };
      this.querySelectorAll('[data-m2u-price]').forEach(input => input.addEventListener('input', validatePrices, { signal }));
      form.addEventListener('invalid', event => {
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      }, { signal, capture: true });
      const stock = this.querySelector('[data-m2u-stock]');
      if (stock) {
        const nativeOptions = Array.from(this.querySelectorAll('[data-m2u-native-availability] input'));
        const inStock = nativeOptions.find(input => input.value === '1');
        const outOfStock = nativeOptions.find(input => input.value === '0');
        stock.checked = Boolean(inStock?.checked && !outOfStock?.checked);
        stock.addEventListener('change', () => {
          nativeOptions.forEach(input => { input.checked = stock.checked && input.value === '1'; });
        }, { signal });
        this.querySelector('[data-m2u-stock-control]').hidden = false;
      }
      form.addEventListener('submit', event => {
        event.stopPropagation();
        if (!validatePrices()) {
          event.preventDefault();
          this.querySelectorAll('[data-m2u-price-range]').forEach(range => { range.closest('details').open = true; });
          form.reportValidity();
          return;
        }
        form.querySelectorAll('[data-m2u-preserved]').forEach(input => input.remove());
        const formNames = new Set(Array.from(form.elements, input => input.name).filter(Boolean));
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (owned.has(name) || formNames.has(name) || transient(name)) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.dataset.m2uPreserved = '';
          form.append(input);
        });
      }, { signal });
      form.addEventListener('formdata', event => {
        this.querySelectorAll('[data-m2u-price]').forEach(input => {
          if (input.value === '') event.formData.delete(input.name);
        });
      }, { signal });
      const clear = this.querySelector('[data-m2u-clear]');
      if (clear) {
        const target = new URL(clear.href, window.location.href);
        const current = new URL(window.location.href);
        target.search = '';
        current.searchParams.forEach((value, name) => {
          if (!name.startsWith('filter.') && !transient(name)) target.searchParams.append(name, value);
        });
        if (!target.searchParams.has('sort_by')) target.searchParams.set('sort_by', form.elements.namedItem('sort_by').value);
        clear.href = target.href;
      }
      this.querySelectorAll('[data-m2u-remove]').forEach(link => {
        const target = new URL(link.href, window.location.href);
        Array.from(target.searchParams.keys()).filter(transient).forEach(name => target.searchParams.delete(name));
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (!name.startsWith('filter.') && !transient(name) && !target.searchParams.has(name)) target.searchParams.append(name, value);
        });
        link.href = target.href;
      });
      this.classList.add('is-enhanced');
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["m2u-shopping-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('m2u-shopping-tools')) return;
  const HISTORY_KEY = 'm2u_recent_products_v1';
  const clean = value => String(value || '').normalize('NFKD').toLowerCase().replace(/(\d)\s*mg\b/g, '$1mg').replace(/[^a-z0-9.]+/g, ' ').trim();
  const aliases = value => clean(value).replace(/\bmelatoning\b/g, 'melatonin').replace(/\bmelatonine\b/g, 'melatonin').replace(/\bquick dissolve\b/g, 'fast dissolve').replace(/\bslow release\b/g, 'time release').replace(/\bextended release\b/g, 'prolonged release').replace(/\bgummies\b/g, 'gummy');
  const oneEdit = (a, b) => {
    if (a === b) return true;
    if (Math.abs(a.length - b.length) > 1) return false;
    let i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a.length === b.length && a[i] === b[j + 1] && a[i + 1] === b[j]) { i += 2; j += 2; continue; }
      if (a.length >= b.length) i++;
      if (b.length >= a.length) j++;
    }
    return edits + (i < a.length || j < b.length ? 1 : 0) <= 1;
  };
  const node = (tag, text, className) => {
    const result = document.createElement(tag);
    if (text != null) result.textContent = text;
    if (className) result.className = className;
    return result;
  };
  let catalogPromise;
  async function catalog(root) {
    if (!catalogPromise) catalogPromise = (async () => {
      const found = new Map(), visited = new Set();
      let url = new URL(root, location.origin);
      url.searchParams.set('section_id', 'm2u-catalog-data');
      while (url) {
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid catalog pagination');
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Catalog unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(html.querySelector('[data-m2u-catalog-page]')?.textContent || 'null');
        if (!data || !Array.isArray(data.products)) throw new Error('Catalog invalid');
        data.products.forEach(product => { if (product.id && product.handle && product.url) found.set(product.id, product); });
        url = data.next ? new URL(data.next, location.origin) : null;
        if (url) url.searchParams.set('section_id', 'm2u-catalog-data');
      }
      return Array.from(found.values());
    })().catch(error => { catalogPromise = undefined; throw error; });
    return catalogPromise;
  }
  class ShoppingTools extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.labels = JSON.parse(this.querySelector('[data-tools-labels]').textContent);
      this.selected = new Map();
      this.form = this.querySelector('[data-tools-form]');
      this.status = this.querySelector('[data-tools-status]');
      this.results = this.querySelector('[data-tools-results]');
      const finder = this.querySelector('details');
      finder?.addEventListener('toggle', () => { if (finder.open) this.startFinder(); });
      if (finder?.open) this.startFinder();
      this.form?.addEventListener('submit', event => { event.preventDefault(); this.showMatches(); });
      this.form?.addEventListener('reset', () => setTimeout(() => this.showMatches(), 0));
      this.querySelector('[data-tools-more]')?.addEventListener('click', () => { this.limit += 6; this.renderResults(); });
      this.querySelector('[data-tools-compare]')?.addEventListener('click', () => this.compare());
      this.querySelector('[data-tools-clear]').addEventListener('click', () => {
        this.recentVersion = (this.recentVersion || 0) + 1;
        try { localStorage.removeItem(HISTORY_KEY); } catch (_) {}
        this.querySelector('[data-tools-recent]').hidden = true;
      });
      this.privacyHandler = () => this.updateRecent();
      document.addEventListener('visitorConsentCollected', this.privacyHandler);
      if (window.Shopify?.customerPrivacy) this.updateRecent();
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error && this.isConnected) this.updateRecent(); });
    }
    disconnectedCallback() { document.removeEventListener('visitorConsentCollected', this.privacyHandler); }
    async startFinder() {
      if (this.loaded || this.loading) return;
      this.loading = true;
      try {
        this.products = await catalog(this.dataset.root);
        ['format', 'strength'].forEach(field => {
          const values = [...new Set(this.products.map(product => product[field]).filter(Boolean))];
          values.sort(field === 'strength' ? (a, b) => parseFloat(a) - parseFloat(b) : (a, b) => a.localeCompare(b));
          values.forEach(value => { const option = node('option', field === 'format' ? this.formatLabel(value) : value); option.value = value; this.form.elements[field].append(option); });
        });
        this.loaded = true;
        this.form.hidden = false;
        this.showMatches();
      } catch (_) { this.status.textContent = this.labels.load_error; }
      finally { this.loading = false; }
    }
    formatLabel(value) {
      const normalized = clean(value);
      const entries = [['fast','format_fast'],['quick','format_fast'],['time','format_time'],['prolonged','format_prolonged'],['regular','format_regular'],['liquid','format_liquid'],['gumm','format_gummy'],['ir xr','format_irxr']];
      return this.labels[entries.find(([word]) => normalized.includes(word))?.[1]] || value;
    }
    showMatches() {
      if (!this.loaded) return;
      const fields = this.form.elements;
      const query = aliases(fields.query.value), tokens = query.split(' ').filter(Boolean);
      const matchesPreferences = product => (!fields.stock.checked || product.available) && (!fields.format.value || product.format === fields.format.value) && (!fields.strength.value || product.strength === fields.strength.value) && (fields.budget.value === '' || product.price <= Number(fields.budget.value) * 100);
      const candidates = this.products.filter(matchesPreferences);
      const searchable = product => aliases([product.title, product.vendor, product.strength, product.format, product.form, product.release, product.pack].join(' '));
      let matches = candidates.filter(product => tokens.every(token => searchable(product).includes(token)));
      let recovered = matches.length > 0 && clean(fields.query.value) !== query;
      if (!matches.length && tokens.length) {
        matches = candidates.filter(product => {
          const words = searchable(product).split(' ');
          return tokens.every(token => words.some(word => word.includes(token) || (token.length >= 5 && oneEdit(token, word))));
        });
        recovered = matches.length > 0;
      }
      this.matches = matches.sort((a, b) => Number(b.available) - Number(a.available));
      this.limit = 6;
      this.status.textContent = recovered ? this.labels.related : matches.length ? this.labels.matches.replace('__COUNT__', matches.length) : this.labels.no_match;
      this.renderResults();
    }
    card(product, selectable) {
      const article = node('article', null, 'm2u-tools__card');
      if (product.image) { const image = node('img'); image.src = product.image; image.alt = product.title; image.loading = 'lazy'; image.width = 180; image.height = 180; article.append(image); }
      article.append(node('h3', product.title));
      const availability = node('p', product.available ? this.labels.available : this.labels.sold_out, 'm2u-tools__availability'); availability.dataset.available = product.available; article.append(availability);
      article.append(node('p', product.priceText, 'm2u-tools__price'));
      if (product.unitPrice) article.append(node('p', product.unitPrice));
      article.append(node('p', [product.strengthText, product.release, product.pack].filter(Boolean).join(' · ')));
      const link = node('a', this.labels.view, 'm2u-tools__card-link'); link.href = product.url; link.setAttribute('aria-label', `${this.labels.view}: ${product.title}`); article.append(link);
      if (selectable) {
        const label = node('label'), check = node('input'); check.type = 'checkbox'; check.checked = this.selected.has(product.id); check.dataset.compareId = product.id;
        check.setAttribute('aria-label', this.labels.select_compare.replace('__PRODUCT__', product.title));
        check.addEventListener('change', () => {
          if (check.checked && this.selected.size >= 3) { check.checked = false; this.status.textContent = this.labels.compare_limit; return; }
          if (check.checked) this.selected.set(product.id, product); else this.selected.delete(product.id);
          this.renderSelection();
        });
        label.append(check, node('span', this.labels.compare_selected)); article.append(label);
      }
      return article;
    }
    renderResults() {
      this.results.replaceChildren(...this.matches.slice(0, this.limit).map(product => this.card(product, true)));
      this.querySelector('[data-tools-more]').hidden = this.limit >= this.matches.length;
      this.renderSelection();
    }
    renderSelection() {
      const selection = this.querySelector('[data-tools-selection]');
      selection.replaceChildren(); selection.hidden = !this.selected.size;
      if (this.selected.size) selection.append(node('span', this.labels.compare_help));
      this.selected.forEach(product => {
        const remove = node('button', `${product.title} ×`); remove.type = 'button'; remove.setAttribute('aria-label', `${this.labels.remove}: ${product.title}`);
        remove.addEventListener('click', () => {
          this.selected.delete(product.id); this.querySelectorAll('[data-compare-id]').forEach(check => { check.checked = this.selected.has(check.dataset.compareId); }); this.renderSelection();
        });
        selection.append(remove);
      });
      this.querySelector('[data-tools-compare]').hidden = this.selected.size < 2;
      this.querySelector('[data-tools-comparison]').hidden = true;
    }
    compare() {
      if (this.selected.size < 2) return;
      const panel = this.querySelector('[data-tools-comparison]'), scroll = node('div', null, 'm2u-tools__table-scroll'), table = node('table'), head = node('thead'), tr = node('tr');
      scroll.tabIndex = 0; scroll.setAttribute('role', 'region'); scroll.setAttribute('aria-label', this.labels.compare_selected);
      const first = node('th', this.labels.compare_selected); first.scope = 'col'; tr.append(first);
      const products = [...this.selected.values()];
      products.forEach(product => { const th = node('th', product.title); th.scope = 'col'; tr.append(th); }); head.append(tr); table.append(head);
      const body = node('tbody');
      const rows = [['price', 'priceText'],['available', 'available'],['strength', 'strengthText'],['format', 'release'],['form', 'form'],['pack', 'pack'],['unit_price', 'unitPrice'],['view', 'url']];
      rows.forEach(([label, field]) => {
        const row = node('tr'), heading = node('th', this.labels[label]); heading.scope = 'row'; row.append(heading);
        products.forEach(product => {
          const cell = node('td');
          if (field === 'url') { const link = node('a', this.labels.view); link.href = product.url; link.setAttribute('aria-label', `${this.labels.view}: ${product.title}`); cell.append(link); }
          else cell.textContent = field === 'available' ? (product.available ? this.labels.available : this.labels.sold_out) : product[field] || this.labels.not_listed;
          row.append(cell);
        }); body.append(row);
      });
      table.append(body); scroll.append(table); panel.replaceChildren(scroll, node('p', this.labels.compare_note, 'm2u-tools__note')); panel.hidden = false; panel.focus(); panel.scrollIntoView({ block: 'nearest', behavior: 'auto' });
    }
    async updateRecent() {
      const recentVersion = this.recentVersion = (this.recentVersion || 0) + 1;
      const allowed = window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
      const section = this.querySelector('[data-tools-recent]');
      if (!allowed) { try { localStorage.removeItem(HISTORY_KEY); } catch (_) {} section.hidden = true; return; }
      let records = [];
      try {
        const stored = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
        if (Array.isArray(stored)) records = stored.filter(item => item && /^[a-z0-9-]+$/.test(item.handle) && Number.isFinite(item.at) && item.at <= Date.now() && Date.now() - item.at < 2592000000).slice(0, 6);
        const current = this.dataset.currentHandle;
        if (current) records = [{ handle: current, at: Date.now() }, ...records.filter(item => item.handle !== current)].slice(0, 6);
        localStorage.setItem(HISTORY_KEY, JSON.stringify(records));
      } catch (_) { return; }
      const handles = records.map(item => item.handle).filter(handle => handle !== this.dataset.currentHandle);
      if (!handles.length) return;
      try {
        const products = await catalog(this.dataset.root);
        if (recentVersion !== this.recentVersion || window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() !== true) return;
        const recent = handles.map(handle => products.find(product => product.handle === handle)).filter(Boolean).slice(0, 3);
        this.querySelector('[data-tools-recent-grid]').replaceChildren(...recent.map(product => this.card(product, false))); section.hidden = !recent.length;
      } catch (_) { section.hidden = true; }
    }
  }
  customElements.define('m2u-shopping-tools', ShoppingTools);
})();
  } catch(e) { console.error(e); }
})();

})();
